import { render, staticRenderFns } from "./LaboratoryLegalPartners.vue?vue&type=template&id=2e115664&scoped=true"
import script from "./LaboratoryLegalPartners.vue?vue&type=script&lang=js"
export * from "./LaboratoryLegalPartners.vue?vue&type=script&lang=js"
import style0 from "./LaboratoryLegalPartners.vue?vue&type=style&index=0&id=2e115664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e115664",
  null
  
)

export default component.exports